import React from 'react';
import ReactDOM from 'react-dom/client';
import { initInstallPrompt } from './utils/pwaInstall';
import { registerServiceWorker } from './utils/swUpdate';
import './index.css';
import './styles/colors.css';
import './styles/unified-responsive.css';
import './styles/shared-ui.css';
import './styles/adminlte-content-skin.css';
import App from './App';

if (typeof window !== 'undefined') {
  initInstallPrompt();
}

if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    registerServiceWorker();
  } else {
    console.log('[PWA] Service Worker nao registrado em desenvolvimento.');
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
